import { render } from "./AddressForm.vue?vue&type=template&id=7aabef98"
import script from "./AddressForm.vue?vue&type=script&lang=js"
export * from "./AddressForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/components/AddressForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7aabef98"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7aabef98', __exports__)) {
    api.reload('7aabef98', __exports__)
  }
  
  module.hot.accept("./AddressForm.vue?vue&type=template&id=7aabef98", () => {
    api.rerender('7aabef98', render)
  })

}


export default __exports__